import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import axios from "axios";

import router from "./router";
import store from "./store";

require("@/store/subscriber");

require("./mixin.js");
require("./axios.js");
require('./filters.js')

// Import and configure vue-toastification
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

Vue.use(Toast, {
  position: "top-right",
  timeout: 4000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false
});

Vue.config.productionTip = false;

// Global error handler for uncaught Vue errors
Vue.config.errorHandler = function(err, vm, info) {
  console.error('[Vue Error]', err, info);

  if (store.getters['auth/authenticated']) {
    axios.post('/client_error_logs', {
      error_type: 'VUE_ERROR',
      message: err.message || String(err),
      source_url: window.location.href,
      stack_trace: err.stack || null,
      severity: 'error',
      metadata: {
        component: vm && vm.$options ? (vm.$options.name || vm.$options._componentTag || 'Unknown') : 'Unknown',
        lifecycle_hook: info,
      },
    }).catch(() => {});
  }
};

// Catch unhandled promise rejections
window.addEventListener('unhandledrejection', function(event) {
  if (store.getters['auth/authenticated']) {
    axios.post('/client_error_logs', {
      error_type: 'UNHANDLED_PROMISE_REJECTION',
      message: event.reason ? (event.reason.message || String(event.reason)) : 'Unknown',
      source_url: window.location.href,
      stack_trace: event.reason && event.reason.stack ? event.reason.stack : null,
      severity: 'warning',
    }).catch(() => {});
  }
});

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

import CryptoJS from "crypto-js";
window.CryptoJS = CryptoJS;
// Vue.component("CryptoJS", CryptoJS);

// Import Laravel Echo for WebSocket
import Echo from "./plugins/echo";
Vue.prototype.$echo = Echo;
window.Echo = Echo;


store.dispatch("auth/attempt", localStorage.getItem("token")).then(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount("#app");
});
